<template>
  <header class="nav-after">
    <div class="container">
      <a class="logo-header" href="/" title="retour à l'accueil">
        <img :src="logo" :style="{ width: tailleLogo }" />
      </a>
    </div>
  </header>
</template>

<script>
import navigationSecondaire from "@/components/comp.navigationSecondaire.vue";

export default {

  name: "entete",
  components: {
    navigationSecondaire,
  },
  props: {
    logo: {
      type: String,
      required: true
    },
    tailleLogo: {
      type: String,
      default: "20rem" // Par défaut, petit logo
    }
  },
};
</script>
